module.exports = __webpack_public_path__ + "img/logo_katsuwin.874db3d7.png";